import Phaser from 'phaser';
import { VIEWPORT_EVENTS } from '../constants/Events';
import { ScreenBackground } from '../display/ScreenBackground';

/**
 * @alias class.SceneBase
 * @description  Base scene class with some built in functionality
 *
 */
class SceneBase extends Phaser.Scene {
  constructor({ key, active = false }) {
    super({ key, active });
    this._sceneKey = key;
    this._simpleButtons = [];
  }

  init() {
    const { width, height } = this.game.defaultDimensions;
    this.defaultWidth = width;
    this.defaultHeight = height;
  }

  loadComplete() {
    if (this.loadScreen) {
      this.loadScreen.destroy();
      this.loadScreen = null;
    }
  }

  create(options) {
    options;
    this.events.on('shutdown', this.shutdown, this);
    this.events.on('pause', this.onScenePaused, this);
    this.events.on('resume', this.onSceneResumed, this);

    this.game.viewportController.events.on(VIEWPORT_EVENTS.UPDATED, this.handleViewUpdate, this);
    this.handleViewUpdate(this.game.viewportController.viewport);
  }

  /**
   * get the viewport controller
   */
  getViewport() {
    return this.game.viewportController;
  }

  addButton(btn) {
    this._simpleButtons.push(btn);
  }

  removeButton(btn) {
    this._simpleButtons = this._simpleButtons.filter((e) => e != btn);
  }

  disableAllButtons() {
    this._simpleButtons?.forEach((e) => e.disable(true));
  }

  restoreAllButtons() {
    this._simpleButtons?.forEach((e) => e.restore());
  }

  /**
   * Set the background image of the scene
   * @param {string} key key of background image to display
   */
  setBackground(key) {
    if (this.bg) {
      this.bg.setTexture(key);
    } else {
      this.bg = new ScreenBackground(this, key);
      this.add.existing(this.bg);
    }
  }

  /**
   * Set t he background colour of the scene, applies to camera
   * @param {number} colour colour to set background
   */
  setBackgroundColour(colour) {
    this.cameras.main.setBackgroundColor(colour);
  }

  /**
   * Automatically called when scene is updated
   * By default does nothing, intended for override
   */
  handleViewUpdate(viewport) {
    viewport;
  }

  /**
   * Automatically called when scene is paused
   * By default does nothing, intended for override
   */
  onScenePaused() {}

  /**
   * Automatically called when scene is resumed
   * By default does nothing, intended for override
   */
  onSceneResumed() {}

  shutdown() {
    this.game.viewportController.events.off(VIEWPORT_EVENTS.UPDATED, this.handleViewUpdate, this);

    this._simpleButtons = [];
    this.events.off('shutdown', this.shutdown, this);
    this.events.off('pause', this.onScenePaused, this);
    this.events.off('resume', this.onSceneResumed, this);
    if (this.bg) {
      this.bg.destroy(true);
      this.bg = null;
    }
    if (this.loadScreen) {
      this.loadScreen.destroy(true);
      this.loadScreen = null;
    }
  }
}

export { SceneBase };
